import { useEffect, useMemo, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import './styles.scss'

const Gallery = ({ data }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [ready, setReady] = useState(false)

  const swiperKey = useMemo(() => Math.random().toString(36).slice(2), [])
  const thumbsKey = useMemo(() => Math.random().toString(36).slice(2), [])

  useEffect(() => {
    if (thumbsSwiper && !thumbsSwiper.destroyed) {
      const id = setTimeout(() => {
        setReady(true)
      }, 0)
      return () => clearTimeout(id)
    }
  }, [thumbsSwiper])

  return (
    <section className='gallerysection'>
      <div className='gallerysection__contain'>
        {ready && (
          <Swiper
            spaceBetween={10}
            navigation
            thumbs={{
              swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
            }}
            loop={false}
            slidesPerView={1}
            className='gallery-swiper'
            key={swiperKey}
          >
            {data.map((item, index) => (
              <SwiperSlide key={`main-slide-${item.path || index}`}>
                <img
                  src={item?.path}
                  alt={item?.alt}
                  height={150}
                  className='img-animation'
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={4}
          freeMode
          watchSlidesProgress
          modules={[FreeMode, Navigation, Thumbs]}
          className='gallery-swipertabs'
          key={thumbsKey}
        >
          {data.map(item => (
            <SwiperSlide key={item.path} style={{ height: 150 }}>
              <img
                src={item?.path}
                alt={item?.alt}
                className='img-animation'
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default Gallery
